var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.course)?_c('div',[_c('WhiteBoard',{attrs:{"course":_vm.course}})],1):(_vm.loading)?_c('LoadingSpinner'):_c('div',[_vm._v(" No course found ")])
}
var staticRenderFns = []

export { render, staticRenderFns }